export default __webpack_public_path__ + "static/media/chegou.3f5ba6d5.webm";